import { o2oApi, enrollApi } from 'yxt-biz-pc/packages/api';

/**
 * 项目详情
 */
export const getProject = (id) => {
  return o2oApi.get(`/enroll/projects/${id}`);
};

/**
 * 报名头部信息
 */
export const getEnrollSummary = (enrollId, orgId) => {
  return enrollApi.get(`/projects/getSummaryInfo/${enrollId}?orgId=${orgId}`);
};

/**
 * 报名列表
 */
export const postCheckList = (query) => {
  let { limit, current, ...body } = query;
  return enrollApi.post('/records/check-search', body, { params: { limit, current } });
};

/**
 * 导出报名列表数据
 */
export const exportCheckList = (params) => {
  return enrollApi.post('records/check-search/export', params);
};

/**
 * 催促报名
 */
export const sendEnrollurgeMsg = (params) => {
  return enrollApi.post('/send/urge/msg', params);
};

/**
 * 报名开始
 */
export const startEnroll = (enrollId) => {
  return enrollApi.put(`/projects/resume/${enrollId}`);
};

/**
 * 报名暂停
 */
export const stopEnroll = (enrollId) => {
  return enrollApi.put(`/projects/pause/${enrollId}`);
};

/**
 * 取消资格
 */
export const cancelBatch = (params) => {
  return enrollApi.put('/records/batch-cancel', params);
};

/**
 * 添加学员
 */
export const addStudent = (params) => {
  return enrollApi.post('/stu/records/batch-add', params);
};

// 获取OSS配置
export const getSts = () => {
  return enrollApi.get('/stss');
};
